import { Trans, t } from '@lingui/macro';

import FormSection from '../../form/FormSection';
import { GROUPS_ADMIN_BUSINESS_SERVICES_COLUMNS, GROUPS_ADMIN_BUSINESS_SERVICES_FIELD } from './GroupsAdminConstants';
import ListSelectorField from '../../form/ListSelectorField';
import { SORT_ASC } from '../../../utilities/FormUtilities';
import { useGroupAdminStyles } from './GroupsAdminUtils';

const initialSort = [{ property: 'name', direction: SORT_ASC }];
const selectionDataSource = {
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        searchFields: ['name', 'description', 'tags'],
    },
    initialSort,
};

const selectedDataSource = {
    ...selectionDataSource,
    url: '/query/admin/business-services/findSelected',
};

const availableDataSource = {
    ...selectionDataSource,
    url: '/query/admin/business-services/findAvailable',
};

const idsDataSource = {
    params: selectionDataSource.params,
    url: '/query/admin/business-services/selectionUUIDs',
};

export function GroupsAdminBusinessServicesSection({
    formData,
    setBusinessServicesSelectionDirty,
    isEditingDefaultGroup,
}) {
    const styles = useGroupAdminStyles();

    const emptyGridText = isEditingDefaultGroup ? (
        <Trans>
            The <strong>Default</strong> group can view data from all Business Services in the application
        </Trans>
    ) : (
        t`There are no Business Services in this Group`
    );

    return (
        <FormSection title={t`Business Services`}>
            <div className={styles.selectorWrapper}>
                <ListSelectorField
                    gridColumns={GROUPS_ADMIN_BUSINESS_SERVICES_COLUMNS}
                    sorters={initialSort}
                    dbSelected={formData?.businessServices?.ids || []}
                    selectedDataSource={selectedDataSource}
                    availableDataSource={availableDataSource}
                    idsDataSource={idsDataSource}
                    fieldName={GROUPS_ADMIN_BUSINESS_SERVICES_FIELD}
                    addButtonText={t`Add Business Services`}
                    removeButtonText={t`Remove`}
                    setSelectionIsDirty={setBusinessServicesSelectionDirty}
                    selectedEmptyGridText={emptyGridText}
                    // Disable field and hide actions if user is editing the default group
                    disabled={isEditingDefaultGroup}
                    hideActions={isEditingDefaultGroup}
                />
            </div>
        </FormSection>
    );
}
